module.exports = __webpack_public_path__ + "da8ec5c1cf9f09d298a13430eb7240d5.MP3";